import React, {useContext} from 'react';
import {RulesListDialog} from '../../../components/RulesListDialog/RulesListDialog';
import {DialogToolbarContent} from '../../../../../components/Dialog/DialogToolbar/DialogToolbar';
import {overviewDialogID} from '../../../constants';
import {AutomationContext} from '../../../context';
import {RuleDialog} from '../../../components/RuleDialog/RuleDialog';
import {texts} from '../texts';
import {BPMStatusCondition} from '../components/RuleDialog.parts/BPMStatusCondition';

type Props = {
    fromStatus: string;
    toStatus: string;
};

export const BPMRulesView = (props: Props) => {
    const {fromStatus, toStatus} = props;

    const {isAutomationOpen, singleRuleOpen, automationType, closeAutomation} =
        useContext(AutomationContext);

    if (isAutomationOpen) {
        const isStatus = Boolean(toStatus && !fromStatus);
        const subTitle = isStatus ? (
            toStatus
        ) : (
            <>
                {fromStatus}&nbsp;
                <span className="text-color-primary-700">{texts.to_status_label}</span>&nbsp;
                {toStatus}
            </>
        );

        if (singleRuleOpen) {
            return (
                <RuleDialog
                    session={'empty_session'}
                    type={automationType}
                    isOpen={singleRuleOpen}
                    showValidForOptions={false}
                    title={
                        fromStatus && toStatus
                            ? texts.path_open_rule_title
                            : texts.status_open_rule_title
                    }
                    subtitle={subTitle}
                    help={texts.status_rule_help}
                    specialCondition={isStatus ? <BPMStatusCondition /> : null}
                />
            );
        }

        return (
            <RulesListDialog
                isOpen
                session={'empty_session'}
                type={automationType}
                onClose={closeAutomation}
                toolbarContent={
                    <DialogToolbarContent
                        mainTitle={
                            fromStatus && toStatus
                                ? texts.path_open_rule_title
                                : texts.status_dialog_rules_title
                        }
                        subTitle={subTitle}
                        helpText={texts.status_dialog_rules_help}
                        tooltipPortalID={overviewDialogID}
                    />
                }
            />
        );
    }

    return null;
};
